module.exports = __webpack_public_path__ + "img/zs.ccd50479.png";